// extracted by mini-css-extract-plugin
export default {"zoomImageWrapper":"style_zoomImageWrapper__Jk0-s","zoomControl":"style_zoomControl__32Pk3","imageContainer":"style_imageContainer__FxbrR","zoomedImage":"style_zoomedImage__MGZxx"};